import React, { useState, useEffect } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete';
import PropTypes from 'prop-types';

import { translate } from '../Services/translation';
import constants from '../constants';

const AddressSearchBar = ({ url }) => {
  const [address, setAddress] = useState('');
  const [coordinates, setCoordinates] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const [googleMapScriptLoaded, setGoogleMapScriptLoaded] = useState(false);

  const handleSelect = async (address, placeId) => {
    geocodeByPlaceId(placeId)
      .then((result) => getLatLng(result[0]))
      .then((latLng) => {
        setAddress(address);
        setCoordinates(latLng);
      })
      .catch((error) => console.error('Error', error));
  };

  const handleSearch = () => {
    const { lat, lng } = coordinates;

    if (!lat || !lng) {
      setErrorMessage(true);
    } else {
      window.location.href = `${url}?lat=${lat}&lng=${lng}`;
    }
  };

  const appendScript = (url) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);
      document.head.append(script);
      script.src = url;
    });
  };

  useEffect(() => {
    // Load google lib if it is not loaded yet.
    if (!window.google) {
      appendScript(
        `https://maps.googleapis.com/maps/api/js?key=${constants.googleMapApiKey}&callback=Function.prototype&libraries=places`
      ).then(() => {
        setGoogleMapScriptLoaded(true);
      });
    }
  }, []);

  return (
    <>
      {googleMapScriptLoaded && (
        <PlacesAutocomplete
          value={address}
          onChange={setAddress}
          onSelect={handleSelect}
          searchOptions={{
            componentRestrictions: {
              country: ['no'],
            },
            types: ['address'],
          }}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <>
              <div className="address-search">
                <i className="address-search__icon"></i>
                <input
                  {...getInputProps({
                    placeholder: translate('general.search'),
                    className: 'address-search__input',
                  })}
                  onFocus={() => setErrorMessage(false)}
                />
                <button
                  type="button"
                  className="address-search__search-button"
                  onClick={() => handleSearch()}
                >
                  {translate('general.search')}
                </button>
              </div>
              {errorMessage && (
                <div className="address-search__error-message">
                  {translate('general.errorMessageChooseAddress')}
                </div>
              )}
              {suggestions.length > 0 && (
                <ul className="suggestions">
                  {loading ? <div>...loading</div> : null}
                  {suggestions.map((suggestion, idx) => {
                    const className = suggestion.active
                      ? 'suggestion-item__active'
                      : 'suggestion-item';
                    return (
                      <li
                        {...getSuggestionItemProps(suggestion, {
                          className,
                        })}
                        key={idx}
                      >
                        {suggestion.description}
                      </li>
                    );
                  })}
                </ul>
              )}
            </>
          )}
        </PlacesAutocomplete>
      )}
    </>
  );
};

export default AddressSearchBar;

AddressSearchBar.propTypes = {
  url: PropTypes.string.isRequired,
};
